import styled from "styled-components";

export const WrapperAccordion = styled.div`
  .MuiAccordionSummary-content {
    font-weight: bold;
  }
  .MuiPaper-root {
    box-shadow: 0px 0px 4px -2px;
  }
`;
